// extracted by mini-css-extract-plugin
export var accordionBody = "style-mod--accordion-body--0e31e";
export var accordionCard = "style-mod--accordion-card--09776";
export var accordionContent = "style-mod--accordion-content--7cecc";
export var accordionIcon = "style-mod--accordion-icon--9af4e";
export var accordionIconOpen = "style-mod--accordion-icon-open--cd8aa";
export var accordionTitle = "style-mod--accordion-title--e0620";
export var cardHeader = "style-mod--card-header--095bd";
export var clipStar = "style-mod--clip-star--891ed";
export var collapsed = "style-mod--collapsed--62c63";
export var content = "style-mod--content--571a0";
export var expanded = "style-mod--expanded--91acd";
export var faqButton = "style-mod--faq-button--f3ec7";
export var faqButtonFoodboom = "style-mod--faq-button-foodboom--845d8";
export var panLandingContent = "style-mod--pan-landing-content--d44e6";
export var panLandingTaTitle = "style-mod--pan-landing-ta-title--f0f18";
export var rating = "style-mod--rating--a7056";
export var ratingDesc = "style-mod--rating-desc--4c368";
export var taTitle = "style-mod--ta-title--1c485";
export var textAccordion = "style-mod--text-accordion--e9d4d";